/*
* Makes a API call to get the available address locations of a restaurant
* @param required 
* {
* lavuTogoName : string,
* jwt : string,
* tokenId : string,
* }
*/
import axios from 'axios';
import { PICKUP_AND_DINEIN_ADDRESS_URL } from '../util/urls';
import { DELIVERY_ADDRESS_URL } from '../util/urls';
import { LAVU_TO_GO_LOCATION_ADDRESS } from '../util/urls';
import { DINING_OPTIONS } from '../util/Constants';
import { requestHeaders } from './api';

export const SearchLavutogoLocations = ({ lavuTogoName, jwt, tokenId }) => {
  return axios.get(
    `${LAVU_TO_GO_LOCATION_ADDRESS}/tokenId/${tokenId}/lavutogoname/${lavuTogoName}`,
    requestHeaders(jwt)
  );
};

export const SearchAvailableAddress = ({
  streetAddress,
  dataname,
  diningOption,
  jwt,
  tokenId,
  rname,
}) => {
  const body = {
    lavu_togo_name: rname,
    streetAddress: streetAddress,
    diningOption: diningOption,
    dataname: dataname,
  };
  const url =
    diningOption === DINING_OPTIONS['Delivery']
      ? DELIVERY_ADDRESS_URL
      : PICKUP_AND_DINEIN_ADDRESS_URL;
  return axios.post(`${url}tokenId/${tokenId}`, body, requestHeaders(jwt));
};

export const FilterAddress = ({
  foundAddresses,
  filterWithDataName,
  dataName,
}) => {
  /*
  * If user is addressed to come from checkout for changing in dining
  * allow only current address for order
  */
  if (filterWithDataName === true && foundAddresses) {
    let filteredAddress = [];
    for (let i = 0; i < foundAddresses.length; i++) {
      if (dataName.toLowerCase() === foundAddresses[i].dataname.toLowerCase()) {
        filteredAddress.push(foundAddresses[i]);
      }
    }
    foundAddresses = filteredAddress;
  }
  return {
    foundAddresses: foundAddresses,
    maplocations: ParseMapLocationsList(foundAddresses),
  };
};

export const ParseMapLocationsList = addressList => {
  let locations = [];
  if (addressList && addressList.length) {
    for (let i = 0; i < addressList.length; i++) {
      locations.push({
        formattedAddress: `${addressList[i].title}, ${
          addressList[i].address
        }, ${addressList[i].city}, ${addressList[i].state}-${
          addressList[i].zip
        }`,
        lattitude: addressList[i].sourcelat,
        longitude: addressList[i].sourcelng,
        id: addressList[i].id,
        title: addressList[i].title,
      });
    }
  }
  return locations;
};



// WEBPACK FOOTER //
// ./src/api/searchForAddress.js